import React from 'react';
import {Dialog, DialogBackdrop, DialogPanel} from "@headlessui/react";

const ModalImage = ({open, setOpen, imgUrl}) => {
    return (
        <Dialog open={open} onClose={setOpen} onClick={() => setOpen(false)} className="relative z-[9999]">
            <DialogBackdrop
                transition
                className="fixed inset-0 bg-black opacity-50 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
            />

            <div className="fixed h-full inset-0 flex w-screen items-center justify-center p-4" onClick={() => setOpen(false)}>
                <DialogPanel className="max-w-[75%] space-y-4 p-12 h-full w-full z-[60]">
                    <div style={{height: "100%", background: `url(${imgUrl}) center center / contain no-repeat`, backgroundSize: "contain"}} onClick={() => setOpen(false)}></div>
                </DialogPanel>
            </div>
        </Dialog>
    );
};

export default ModalImage;